import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-[11px] font-bold uppercase tracking-wider text-gray-400" }
const _hoisted_2 = { class: "relative flex h-16 w-24 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-gradient-to-br from-orange-300 via-pink-500 to-purple-600" }
const _hoisted_3 = { class: "flex size-7 items-center justify-center rounded-full bg-white/90" }
const _hoisted_4 = { class: "absolute bottom-1 right-1 rounded-md bg-black/70 px-1.5 py-0.5 text-[10px] font-bold text-white" }
const _hoisted_5 = { class: "min-w-0 flex-1" }
const _hoisted_6 = { class: "truncate font-semibold text-gray-900" }
const _hoisted_7 = { class: "mt-0.5 truncate text-xs text-gray-500" }
const _hoisted_8 = { class: "ml-auto shrink-0 rounded-full bg-teal-50 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-teal-700" }
const _hoisted_9 = { class: "mt-6 text-[11px] font-bold uppercase tracking-wider text-gray-400" }
const _hoisted_10 = { class: "mt-2 space-y-2" }
const _hoisted_11 = { class: "flex size-7 items-center justify-center rounded-full bg-white/90" }
const _hoisted_12 = { class: "absolute bottom-1 right-1 rounded-md bg-black/70 px-1.5 py-0.5 text-[10px] font-bold text-white" }
const _hoisted_13 = { class: "min-w-0 flex-1" }
const _hoisted_14 = { class: "truncate font-semibold text-gray-900" }
const _hoisted_15 = { class: "mt-0.5 truncate text-xs text-gray-500" }
const _hoisted_16 = { class: "ml-auto inline-flex shrink-0 items-center gap-1 rounded-full bg-emerald-50 px-3 py-1 text-[11px] font-semibold text-emerald-700" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { PlayIcon } from '@heroicons/vue/24/solid';
import { CheckIcon } from '@heroicons/vue/24/outline';
import useLivviaStore from '@/store/livvia';


export default /*@__PURE__*/_defineComponent({
  __name: 'LivesList',
  setup(__props) {

const { t } = useI18n();
const livvia = useLivviaStore();

// TODO: replace mock data with real InstagramLiveMetadata / FacebookLiveMetadata
// fetched from the plugin store when we finalise post-live detection (Q1).
const latest = computed(() => ({
  title: livvia.lastLive?.timestampLabel || t('livvia.postLive.mock.latestTitle'),
  subtitle: t('livvia.postLive.mock.latestSubtitle', {
    comments: livvia.lastLive?.commentsCount ?? 340,
    platform: livvia.lastLive?.platform === 'facebook' ? 'Facebook' : 'Instagram',
  }),
  duration: livvia.lastLive?.durationLabel || '1h 42',
}));

// Previous-lives strip is placeholder-only until the plugin store's
// live-metadata endpoint is wired here. Kept behind a DEV gate so a
// Natura/Boticário demo never sees hardcoded fake counts like "31 carts".
// TODO: replace with real InstagramLiveMetadata / FacebookLiveMetadata
// once post-live detection (Q1) lands; then drop the DEV gate.
const IS_DEV_PREVIEW = process.env.NODE_ENV !== 'production';

const previous = IS_DEV_PREVIEW ? [
  {
    id: 'p1',
    title: t('livvia.postLive.mock.previous1Title'),
    subtitle: t('livvia.postLive.mock.previous1Subtitle'),
    duration: '2h 05',
    thumbClass: 'bg-gradient-to-br from-sky-400 via-indigo-500 to-purple-600',
    cartsCount: 31,
  },
  {
    id: 'p2',
    title: t('livvia.postLive.mock.previous2Title'),
    subtitle: t('livvia.postLive.mock.previous2Subtitle'),
    duration: '58 min',
    thumbClass: 'bg-gradient-to-br from-teal-400 via-sky-500 to-indigo-500',
    cartsCount: 24,
  },
] : [];

const onLatestClick = () => {
  livvia.startBuildingCarts();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('livvia.postLive.sectionLatest')), 1),
    _createElementVNode("button", {
      type: "button",
      class: "mt-2 flex w-full cursor-pointer items-center gap-3 rounded-2xl border-2 border-teal-500 bg-white p-3 text-left shadow-sm ring-2 ring-teal-100 transition hover:brightness-[1.02] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600",
      onClick: onLatestClick
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_unref(PlayIcon), { class: "ml-0.5 size-3.5 text-gray-900" })
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(latest.value.duration), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(latest.value.title), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(latest.value.subtitle), 1)
      ]),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('livvia.postLive.tagNew')), 1)
    ]),
    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)('livvia.postLive.sectionPrevious')), 1),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(previous), (live) => {
        return (_openBlock(), _createElementBlock("div", {
          key: live.id,
          class: "flex items-center gap-3 rounded-2xl bg-white p-3 shadow-sm ring-1 ring-gray-200"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["relative flex h-16 w-24 shrink-0 items-center justify-center overflow-hidden rounded-xl", live.thumbClass])
          }, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_unref(PlayIcon), { class: "ml-0.5 size-3.5 text-gray-900" })
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(live.duration), 1)
          ], 2),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(live.title), 1),
            _createElementVNode("p", _hoisted_15, _toDisplayString(live.subtitle), 1)
          ]),
          _createElementVNode("span", _hoisted_16, [
            _createVNode(_unref(CheckIcon), { class: "size-3" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.postLive.tagCarts', { count: live.cartsCount })), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})